module.exports = "<div class=\"panel-box-body position-relative\">\n  <!-- <span class=\"n-value\" *ngIf=\"nGraphValue\">N= {{nGraphValue}}</span> -->\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div #chartTarget class=\"w-100 m-auto\">\n        <div id=\"container-speed\"></div>\n        <div id=\"container-rpm\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/self-service-tab/components/sst-graph-chart/sst-graph-chart.component.html
// module id = ./src/app/feature/main/roles-shared/components/self-service-tab/components/sst-graph-chart/sst-graph-chart.component.html
// module chunks = main